<dx-popup [(visible)]="visible" (visibleChange)="visibleChange.emit($event)" [showTitle]="false" [width]="'calc(100vw - 32px)'" [maxWidth]="1080" [height]="'calc(100vh - 32px)'" [maxHeight]="760" [dragEnabled]="false" [hideOnOutsideClick]="false" [showCloseButton]="false">
	<div *dxTemplate="let data of 'content'">
		<div class="lookup-editor" data-cy="mapper-lookup-editor" *ngIf="row && lookup" (mapper-configure-lookup)="configureLookupFromEvent($event)">
			<header class="lookup-header">
				<div>
					<div class="lookup-kicker">Related record lookup</div>
					<h2>{{ row.targetDisplayName }} lookup</h2>
					<p>Find one {{ referenceEntityLabel }} record and use it to fill {{ row.targetDisplayName }}.</p>
				</div>
				<button type="button" class="close-button" aria-label="Close lookup editor" (click)="cancel.emit()">&times;</button>
			</header>

			<div class="lookup-body">
				<section class="lookup-overview">
					<div class="lookup-overview-copy">
						<span class="overview-label">Find one</span>
						<strong>{{ referenceEntityLabel }}</strong>
					</div>
					<div class="lookup-route-arrow" aria-hidden="true">&rarr;</div>
					<div class="return-field-picker">
						<label>Return field / key</label>
						<dx-select-box [items]="returnFieldOptionGroups" [grouped]="true" [displayExpr]="returnFieldDisplayExpr" valueExpr="path" [value]="lookup.returnFieldPath" [searchEnabled]="true" [elementAttr]="returnFieldElementAttr" placeholder="Choose return field" (onValueChanged)="onReturnFieldChanged($event.value)">
						</dx-select-box>
						<small>This value is written into the target field.</small>
					</div>
					<div class="lookup-route-arrow" aria-hidden="true">&rarr;</div>
					<div class="lookup-overview-copy">
						<span class="overview-label">Fill target field</span>
						<strong>{{ row.targetDisplayName }}</strong>
					</div>
				</section>

				<section class="conditions-section">
					<div class="conditions-heading">
						<div>
							<div class="section-eyebrow">Matching rules</div>
							<h3>Match {{ lookup.matchMode === 'Any' ? 'any' : 'all' }} condition{{ lookup.criteria.length === 1 ? '' : 's' }}</h3>
							<p>Match fields identify the record; the return field above determines the value written back.</p>
						</div>
						<div class="conditions-actions">
							<div class="match-mode-switch" data-cy="mapper-lookup-match-mode" role="group" aria-label="Lookup condition matching" *ngIf="lookup.criteria.length > 1">
								<button type="button" [class.active]="lookup.matchMode !== 'Any'" (click)="setMatchMode('All')">All</button>
								<button type="button" [class.active]="lookup.matchMode === 'Any'" (click)="setMatchMode('Any')">Any</button>
							</div>
							<dx-button text="Add condition" type="normal" stylingMode="outlined" (onClick)="addCriterion()"></dx-button>
						</div>
					</div>

					<div class="conditions-list" *ngIf="lookup.criteria.length; else emptyConditions">
						<article class="condition-card" *ngFor="let criterion of lookup.criteria; let i = index">
							<div class="condition-index">{{ i + 1 }}</div>
							<div class="condition-content">
								<div class="condition-equation">
									<div class="condition-prefix">{{ getCriterionJoiner(i) }}</div>
									<div class="condition-field condition-target">
										<label>Match field in {{ referenceEntityLabel }}</label>
										<dx-select-box [items]="referenceFieldOptions" displayExpr="label" valueExpr="path" [(value)]="criterion.targetFieldPath" [searchEnabled]="true" [placeholder]="'Choose ' + referenceEntityLabel + ' field'" (onValueChanged)="onCriterionTargetFieldChanged(criterion, $event.value)">
										</dx-select-box>
									</div>

									<div class="equals-chip">equals</div>

									<div class="condition-field condition-mode">
										<label>Compare with</label>
										<dx-select-box [items]="criterionModeOptions" displayExpr="label" valueExpr="value" [value]="criterion.mode" (onValueChanged)="onCriterionModeChanged(criterion, $event.value)">
										</dx-select-box>
									</div>

									<div class="condition-value" [ngSwitch]="criterion.mode">
										<div class="condition-field" *ngSwitchCase="'SourceField'">
											<label>{{ sourceSystemLabel }} field</label>
											<div class="source-dropdown-editor" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
												<dx-drop-down-box [value]="criterion.sourceFieldPath" [dataSource]="sourceFieldOptions" valueExpr="path" [displayExpr]="sourceFieldDisplayExpr" [placeholder]="'Choose ' + sourceSystemLabel + ' field'" [opened]="isCriterionSourceDropdownOpened(criterion)" [showClearButton]="!!criterion.sourceFieldPath" [dropDownOptions]="{ width: 520, maxWidth: 'calc(100vw - 24px)' }"
									(onOpened)="setCriterionSourceDropdownOpened(criterion, true)" (onClosed)="setCriterionSourceDropdownOpened(criterion, false)" (onValueChanged)="onCriterionSourceFieldChanged(criterion, $event.value)">
													<div *dxTemplate="let data of 'content'">
														<div class="source-dropdown-content" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
															<div class="source-tree-search">
														<input class="grid-search" type="text" [value]="getCriterionSourceFieldSearchValue(criterion)" (input)="setCriterionSourceFieldSearchValue(criterion, $any($event.target).value)" [placeholder]="'Search ' + sourceSystemLabel + ' fields...'" />
															</div>
															<div class="selected-source-field" *ngIf="criterion.sourceFieldPath">
																<strong>{{ getSourceFieldLabel(criterion.sourceFieldPath) }}</strong>
																<span class="selected-source-field-path">{{ criterion.sourceFieldPath }}</span>
															</div>
															<div class="source-tree-body" (wheel)="$event.stopPropagation()">
																<dx-tree-view [items]="getCachedCriterionSourceTreeItems(criterion)" dataStructure="tree" keyExpr="id" displayExpr="displayName" itemsExpr="items" hasItemsExpr="hasItems" [searchEnabled]="false" [expandEvent]="'click'" [selectByClick]="true" [focusStateEnabled]="true" [activeStateEnabled]="true"
																	(onItemClick)="onCriterionSourceTreeItemClick($event, criterion)" (onItemExpanded)="onSourceTreeItemExpanded($event)">
																	<div *dxTemplate="let item of 'item'" class="source-tree-item">
																		<strong>{{ item.displayName }}</strong>
																		<small *ngIf="item.path">{{ item.path }}</small>
																	</div>
																</dx-tree-view>
															</div>
															<div class="source-tree-actions" *ngIf="criterion.sourceFieldPath">
																<dx-button text="Clear selection" stylingMode="text" type="normal" (onClick)="clearCriterionSourceField(criterion)"></dx-button>
															</div>
														</div>
													</div>
												</dx-drop-down-box>
											</div>
										</div>

										<div class="condition-field" *ngSwitchCase="'Constant'">
											<label>Fixed value</label>
							<dx-select-box *ngIf="isCriterionTargetPicklist(criterion)" [items]="getCriterionConstantPicklistOptions(criterion)" displayExpr="label" valueExpr="value" [value]="criterion.value" [searchEnabled]="true" placeholder="Choose target option" (onValueChanged)="onCriterionValueChanged(criterion, $event.value)"></dx-select-box>
							<dx-text-box *ngIf="!isCriterionTargetPicklist(criterion)" [value]="criterion.value" placeholder="Enter value" (onValueChanged)="onCriterionValueChanged(criterion, $event.value)"></dx-text-box>
										</div>

										<div class="condition-field" *ngSwitchCase="'Expression'">
											<label>Expression result</label>
											<div class="expression-row">
												<div class="expression-preview" [title]="criterion.value || ''">{{ criterion.value || 'No expression yet' }}</div>
												<dx-button text="Edit" type="default" stylingMode="outlined" (onClick)="editCriterionExpression(i)"></dx-button>
											</div>
										</div>
									</div>
								</div>

								<div class="condition-meta">
									<span class="sample-chip" *ngIf="criterion.mode === 'SourceField' && criterion.sourceFieldPath" [class.is-empty]="isCriterionSampleValueEmpty(criterion)">
										Current sample: <strong>{{ getCriterionSampleValueDisplay(criterion) }}</strong>
									</span>
								</div>
							</div>
							<button type="button" class="remove-button" [attr.aria-label]="'Remove condition ' + (i + 1)" (click)="removeCriterion(i)">Remove</button>
						</article>
					</div>

					<ng-template #emptyConditions>
						<div class="empty-conditions">
							<strong>No matching condition yet</strong>
							<span>Add a condition such as Company ID equals a {{ sourceSystemLabel }} account ID.</span>
							<dx-button text="Add first condition" type="default" stylingMode="outlined" (onClick)="addCriterion()"></dx-button>
						</div>
					</ng-template>

					<div class="lookup-guidance">
						<div class="lookup-summary" data-cy="mapper-lookup-summary" aria-live="polite">
							<span>Lookup summary</span>
							<strong>{{ lookupExecutionSummary }}</strong>
						</div>
						<div class="optional-lookup-note" data-cy="mapper-lookup-optional-note" *ngIf="optionalLookupSkipMessage">
							{{ optionalLookupSkipMessage }}
						</div>
					</div>
				</section>

				<details class="advanced-details">
					<summary>Advanced details</summary>
					<div class="advanced-grid">
						<div><span>Related entity</span><strong>{{ referenceEntityLabel }}</strong></div>
						<div><span>Target field</span><strong>{{ row.targetPath }}</strong></div>
						<div><span>Return field</span><strong>{{ lookup.returnFieldPath }}</strong></div>
						<div><span>Match strategy</span><strong>{{ lookup.matchMode === 'Any' ? 'Any condition' : 'All conditions' }}</strong></div>
					</div>
				</details>
			</div>

			<div class="lookup-test-result" data-cy="mapper-lookup-test-result" *ngIf="testRan || testLoading" [attr.data-tone]="testLoading ? 'loading' : testValid ? (testHasResult ? 'success' : 'info') : 'danger'">
				<span class="test-spinner" *ngIf="testLoading" aria-hidden="true"></span>
				<div>
					<strong>{{ testLoading ? 'Testing lookup...' : testValid ? (testHasResult ? 'Lookup resolved' : 'Lookup is valid') : 'Lookup needs attention' }}</strong>
					<span>{{ testLoading ? 'Using the currently loaded source sample.' : testHasResult ? ('Matched one record in ' + referenceEntityLabel + '.') : testMessage }}</span>
					<code *ngIf="!testLoading && testHasResult">Returned {{ returnFieldLabel }}: {{ testResultDisplay }}</code>
				</div>
			</div>

			<footer class="lookup-footer">
				<div class="footer-hint">Changes are kept as a draft until you apply this lookup.</div>
				<div class="footer-actions">
					<span class="apply-disabled-reason" data-cy="mapper-lookup-apply-reason" *ngIf="applyDisabledReason">{{ applyDisabledReason }}</span>
					<dx-button text="Cancel" type="normal" stylingMode="text" (onClick)="cancel.emit()"></dx-button>
					<dx-button text="Test lookup" type="normal" stylingMode="outlined" [elementAttr]="testLookupButtonElementAttr" [disabled]="!canApplyLookup || !canTestLookup || testLoading" (onClick)="testCurrentLookup()"></dx-button>
					<dx-button text="Apply lookup" type="default" stylingMode="contained" [elementAttr]="applyLookupButtonElementAttr" [disabled]="!canApplyLookup" (onClick)="applyLookup()"></dx-button>
				</div>
			</footer>
		</div>
	</div>
</dx-popup>
